import React from "react";
import { useAuth } from "../../context/useAuth";
import Swal from "sweetalert2";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import DashboardIcon from "@mui/icons-material/Dashboard";
import LogoutIcon from "@mui/icons-material/Logout";

const ProfileHoverMenu = () => {
  const { user, logout } = useAuth();

  const logoutHandler = () => {
    Swal.fire({
      title: "Confirm Logout",
      text: "Are you sure you want to log out?",
      icon: "warning",
      confirmButtonText: "Yes, Log Out",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#d33",
      cancelButtonColor: "#0d409b",
      showCancelButton: true,
      reverseButtons: true,
      focusCancel: true,
    }).then((result) => {
      if (result.isConfirmed) {
        logout(); // Proceed with the logout process
      }
    });
  };

  return (
    <div className="group ">
      <div className="flex flex-col justify-start cursor-pointer">
        {user?.fullName && (
          <p className="m-0 p-0 text-sm text-start hidden lg:block text-ellipsis">
            {`Hello, ${user?.fullName}`}
          </p>
        )}

        <p className="m-0 p-0 font-semibold  flex justify-center items-center">
          My Account <KeyboardArrowDownIcon fontSize="small" />
        </p>
      </div>
      <div className="hidden group-hover:flex absolute z-50 bg-white rounded-2xl shadow-md border-2 flex-col right-10 .w-52 w-fit">
        <ul className="p-2 px-4 divide-y divide-slate-200">
          <li className="flex items-center py-4 first:pt-0 last:pb-0">
            <img
              className="h-12 w-12 rounded-full border"
              src="https://acuvisor.s3.ap-south-1.amazonaws.com/dev/Images/Icons/male.svg"
              alt="User"
            />
            <div className="ml-3">
              <p className="text-sm font-semibold text-gray-800">
                {user?.fullName}
              </p>
              <p className="text-sm font-bold text-gray-500 truncate text-ellipsis">
                {user?.email ??
                  user?.mobile?.toString()?.substr(0, 3) +
                    "xxxx" +
                    user?.mobile?.toString()?.substr(7, 3)}
              </p>
            </div>
          </li>
          <li
            className="flex items-center gap-2 py-3 px-4 cursor-pointer hover:bg-gray-100 rounded transition"
            onClick={() => (window.location.href = "/dashboard")}
          >
            <DashboardIcon fontSize="small" className="text-blue-500" />
            <span className="text-sm text-gray-800">Dashboard</span>
          </li>
          <li
            className="flex items-center gap-2 py-3 px-4 cursor-pointer hover:bg-red-50 rounded transition"
            onClick={logoutHandler}
          >
            <LogoutIcon fontSize="small" className="text-red-500" />
            <span className="text-sm text-gray-800">Logout</span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default ProfileHoverMenu;
